import { Banknote, CalendarDays, CheckSquare, FileText, Mail, Megaphone, Palette, Phone, Plane, Receipt, Server, ShieldCheck, ShoppingBag, Users } from 'lucide-react';
import { inferTaskIcon } from './task-icon.js';

const kinds = {
  general: { icon: CheckSquare, label: 'Task', tone: 'neutral' },
  payroll: { icon: Banknote, label: 'Salary & payroll', tone: 'green' },
  billing: { icon: Receipt, label: 'Billing & payments', tone: 'amber' },
  security: { icon: ShieldCheck, label: 'Security', tone: 'teal' },
  meeting: { icon: Phone, label: 'Meeting & call', tone: 'purple' },
  travel: { icon: Plane, label: 'Travel & logistics', tone: 'blue' },
  purchase: { icon: ShoppingBag, label: 'Purchase & renewal', tone: 'amber' },
  technology: { icon: Server, label: 'Technology', tone: 'blue' },
  people: { icon: Users, label: 'People & team', tone: 'rose' },
  design: { icon: Palette, label: 'Design', tone: 'purple' },
  marketing: { icon: Megaphone, label: 'Marketing', tone: 'rose' },
  document: { icon: FileText, label: 'Document & report', tone: 'blue' },
  communication: { icon: Mail, label: 'Email & message', tone: 'teal' },
  planning: { icon: CalendarDays, label: 'Planning & schedule', tone: 'green' },
} as const;

export function TaskIcon({ title }: { title: string }) {
  const kind = inferTaskIcon(title);
  const { icon: Icon, label, tone } = kinds[kind];
  return <span className={`task-glyph task-glyph--${tone}`} data-task-kind={kind} role="img" aria-label={`${label} (automatic icon)`} title={`${label} · automatic icon`}><Icon aria-hidden="true" /></span>;
}
